export default {
  LIST(state, data) {
    state.quoteDistributions = data
  },
  GET(state, data) {
    state.quoteDistribution = data
  },
  PERIODS(state, data) {
    state.periods = data
  },
  FINANCE_ACCEPTED_LETTER_QUOTE(state, data) {
    state.financeAcceptedLetterQuote = data
  },
  FRESH(state, data) {
    state.quoteDistribution = {
      about: '',
      total_quote_type: 100,
      period: null,
      from_org: null,
      ...data,
    }
  },
  OTM_ITM_ACCEPTED_LETTER_QUOTES(state, data) {
    state.otmItmAcceptedLetterQuotes = data
  },
  SET_QUOTE_DISTRIBUTION_ITEM(state, item) {
    state.quoteDistributionItem = { ...item }
  },
  OTM_BALANCE(state, data) {
    state.balance = data
  },
}
